<template>
    <v-dialog v-model="confirmPopup" width="600" height="300">
        <div class="popup-container">
            <img v-if="image" :src="image" alt="Popup Icon" />
            <h2>{{ title }}</h2>
        </div>

    </v-dialog>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        title: String,
        type: String,
        image: String
    },
    computed: {
        confirmPopup: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    },
}
</script>

<style scoped>
.popup-container {
    background-color: #FFFFFF;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
}
</style>